import {ChangeDetectionStrategy, Component, computed, Injectable, input, linkedSignal, signal} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';
import {Autentiseringsmetode, GruppeAggreatModell, GruppeId, GruppeModell, GruppeRessursClient, Invitasjonsstatus} from 'felles-ng2/tjenester/ressurser/generertNg2HttpKlient';
import {medlemmerMedTilgangMedBrukertilknytning, medlemmerMedTilgangUtenBrukertilknytning, medlemmerUtenTilgangMedBrukertilknytning} from 'felles-ng2/modell/medlemModellHjelpere';
import {AdministrasjonMedlemKomponent} from '../administrasjon-medlem/administrasjon-medlem';
import {Navigasjon} from 'web-ng2/tjenester/Navigasjon';
import {TittelVerdiSamlingKomponent} from "web-ng2/delt/komponenter/tittel-verdi/tittel-verdi-samling";
import {TittelVerdiKomponent} from "web-ng2/delt/komponenter/tittel-verdi/tittel-verdi";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";
import {ZonedDateTimeSomPlainDatePipe} from "felles-ng2/pipes/ZonedDateTimeSomPlainDatePipe";

@Component({
    selector: 'administrasjon-gruppe',
    templateUrl: 'administrasjon-gruppe.html',
    styleUrl: 'administrasjon-gruppe.scss',
    imports: [AdministrasjonMedlemKomponent, MatButton, TranslateModule, TittelVerdiSamlingKomponent, TittelVerdiKomponent, FormaterPlainDatePipe, ZonedDateTimeSomPlainDatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdministrasjonGruppeKomponent {
    static ajsSelector = 'administrasjonGruppe';

    gruppe = input.required<GruppeModell>();
    aggregater = input<GruppeAggreatModell | null>(null);

    readonly viserDetaljer = signal(false);
    readonly visningsgruppe = linkedSignal(() => this.gruppe());
    readonly aktiveMedlemmer = computed(() => medlemmerMedTilgangMedBrukertilknytning(this.visningsgruppe().alleMedlemmer));
    readonly invitasjoner = computed(() => medlemmerMedTilgangUtenBrukertilknytning(this.visningsgruppe().alleMedlemmer));
    readonly inaktiveMedlemmer = computed(() => medlemmerUtenTilgangMedBrukertilknytning(this.visningsgruppe().alleMedlemmer));
    readonly autentiseringsmetoder = computed(() => this.visningsgruppe().tillatteAutentiseringsmetoder.map(autentiseringsmetodeTekst));

    constructor(private avhengigheter: AdministrasjonGruppeAvhengigheter,
                private navigasjon: Navigasjon) {
    }

    byttDetaljvisning() {
        this.viserDetaljer.update(vises => !vises);
    }

    async opprettAksjeeierbok() {
        this.visningsgruppe.set(await this.avhengigheter.opprettAksjeeierbok(this.visningsgruppe().id));
    }

    gaaTilEndringshendelser() {
        this.navigasjon.gåTilGruppeEndringshendelser(this.visningsgruppe().id);
    }

    invitasjonsstatusTekst(status: Invitasjonsstatus): string {
        switch (status) {
            case Invitasjonsstatus.ikke_sendt: return 'invitasjon ikke sendt';
            case Invitasjonsstatus.sendt: return 'invitasjon sendt';
            case Invitasjonsstatus.avslått: return 'invitasjon avslått';
            case Invitasjonsstatus.akseptert: return 'invitasjon akseptert';
        }
    }
}

@Injectable({providedIn: 'root'})
export class AdministrasjonGruppeAvhengigheter {
    constructor(private ressurs: GruppeRessursClient) {
    }

    opprettAksjeeierbok(id: GruppeId): Promise<GruppeModell> {
        return this.ressurs.opprettAksjeeierbok(id).somPromise();
    }
}

function autentiseringsmetodeTekst(metode: Autentiseringsmetode): string {
    switch (metode) {
        case Autentiseringsmetode.passord: return 'Passord';
        case Autentiseringsmetode.totpOtp: return 'Kodegenerator';
        case Autentiseringsmetode.smsOtp: return 'Sms';
        case Autentiseringsmetode.criiptoOpenId: return 'E-Id';
    }
}
